import ModalBase from "components/shared/ModalBase";
import { useTranslation } from "react-i18next";
import type { AgreementTemplate } from "store/agreementsStore";

import styles from "./style.module.scss";

interface TemplatePickerModalProps {
    open: boolean;
    onClose: () => void;
    remainingTemplates: AgreementTemplate[];
    onAdd: (templateId: number) => void;
}

const TemplatePickerModal = ({ open, onClose, remainingTemplates, onAdd }: TemplatePickerModalProps) => {
    const [t] = useTranslation();

    return (
        <ModalBase
            open={open}
            onClose={onClose}
            modalTitle={t("ContractSettingsPreferences.SelectTemplate")}
            widthTransition={{ active: true, width: "500px" }}
            contentStyle={{ overflowY: "auto", maxHeight: "50vh" }}
        >
            <div className={styles["template-modal-list"]}>
                {remainingTemplates.map((template) => (
                    <div key={template.id} className={styles["template-modal-item"]} onClick={() => onAdd(template.id)}>
                        {template.name}
                    </div>
                ))}
            </div>
        </ModalBase>
    );
};

export default TemplatePickerModal;
